import { prerender } from "$app/server";
import type { CityMapSummary } from "$lib/api/velatlas/response.types";
import { ServerVelatlasApi } from "$lib/api/velatlas/velatlas.api.server";
import { CityService } from "$lib/features/city/CityService";
import { CityFeatureType } from "$lib/features/cityFeature/cityFeatureType.enum";
import * as v from 'valibot';

const api = new ServerVelatlasApi();

export const getCityMapSummary = prerender(
    v.object({
        cityId: v.string(),
        withCityDetails: v.optional(v.boolean(), false)
    }),
    async ({ cityId, withCityDetails }): Promise<CityMapSummary> => {
        console.log("Getting city summary", { cityId, withCityDetails });
        const mapSummary = await api.getCityMapSummary(cityId);
        if (!withCityDetails) {
            mapSummary.featureCoordinates = mapSummary.featureCoordinates.filter(item => item.type !== CityFeatureType.CITY_DETAILS);
        }
        return mapSummary;
    },
    {
        inputs: () => {
            const cities = CityService.getAllCities();
            return cities.map(city => ({
                cityId: city.id,
                withCityDetails: false
            }));
        }

    }
);